import type { WorkspaceMetadata } from '@toeverything/infra';

import type { WorkspaceSubTab } from '../types';
import { WorkspaceSettingDetail } from './new-workspace-setting-detail';
import { WorkspaceSettingProperties } from './properties';
import { WorkspaceSettingWiki } from './wiki';

export const WorkspaceSetting = ({
  workspaceMetadata,
  subTab,
}: {
  workspaceMetadata: WorkspaceMetadata;
  subTab: WorkspaceSubTab;
}) => {
  switch (subTab) {
    case 'workspace:preference':
      return <WorkspaceSettingDetail workspaceMetadata={workspaceMetadata} />;
    case 'workspace:properties':
      return (
        <WorkspaceSettingProperties workspaceMetadata={workspaceMetadata} />
      );
    case 'workspace:wiki':
      return <WorkspaceSettingWiki workspaceMetadata={workspaceMetadata} />;
  }
};
